var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getStorage, StorageType } from '../utils/storage';
import { concatWithSymbol } from '..';
import { config } from '../config/constants';
import { getOriginOpenId, getUtm, utmKey } from '../utils/preflight';
import { concatURI, sleep } from '../utils/common';
// 当前页面上报信息
export const CurrentPageParams = {};
/** 浏览页面 */
export const pageview = (action) => actionView('pageview', action);
/** 浏览文档 */
export const documentview = (action) => actionView('documentview', action);
/** 观看直播 */
export const webinarview = (action) => actionView('webinarview', action);
/** 观看视频记录时长 */
export const videorecord = (action) => actionView('videorecord', action);
/** 观看视频 */
export const videoview = (action) => actionView('videoview', action);
/** 试看 */
export const preVideoview = (action) => actionView('pre-videoview', action);
/** 搜索 */
export const searchview = (action) => actionView('searchview', action);
/** 下载资料 */
export const downloadview = (action) => actionView('downloadview', action);
/** 答题结果 */
export const answerview = (action) => actionView('answerview', action);
/** 互动分数 */
export const scoreview = (action) => actionView('scoreview', action);
/** 按键点击 */
export const clickview = (action) => actionView('clickview', action);
/** 签到 */
export const signInview = (action) => actionView('signInview', action);
/** 推荐 */
export const recommendview = (action) => actionView('recommendview', action);
/** 分享 */
export const shareview = (action) => actionView('shareview', action);
/** 点赞 */
export const likeview = (action) => actionView('likeview', action);
/** 收藏 */
export const collectview = (action) => actionView('collectview', action);
/** 取消收藏 */
export const uncollectview = (action) => actionView('uncollectview', action);
/** 发送文档至邮箱 */
export const mailDocview = (action) => actionView('mailDoc', action);
/**
 * 行为事件通用处理函数
 * @internal
 * @export
 * @param {ActionKeys} type
 * @param {AllActions} action
 */
export function actionView(type, action) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const utm = getStorage(utmKey, StorageType.session) || {};
        const mergedInfo = Object.assign(Object.assign({ path: window.location.href, uaId: config.uaId }, utm), action);
        if (!mergedInfo.uaId)
            return;
        // 等待CurrentPageParams赋值
        yield sleep(0);
        // cms
        Object.assign(mergedInfo, {
            title: (_a = CurrentPageParams.title) !== null && _a !== void 0 ? _a : mergedInfo.title,
            cms: (_b = CurrentPageParams.cms) !== null && _b !== void 0 ? _b : mergedInfo.cms,
            tagIds: (_c = CurrentPageParams.tagIds) !== null && _c !== void 0 ? _c : mergedInfo.tagIds,
            routeName: CurrentPageParams.routeName
        });
        if (!mergedInfo.title) {
            throw Error('上报标题不能为空');
        }
        // 分享来源
        if (config.trackOriginOpenId) {
            const originOpenId = getOriginOpenId();
            originOpenId && Object.assign(mergedInfo, { originOpenId });
            window.ca('set', 'originOpenId', mergedInfo.originOpenId);
        }
        mergedInfo.title = concatWithSymbol([config.actionPrefix, mergedInfo.title]);
        config.perferFetch ? window.cw('fetch', 'action', undefined, undefined, { type, detail: mergedInfo }, { keepalive: true }) : window.cw('action', type, mergedInfo);
        if (type === 'pageview') {
            // 微站场景
            if (Object.keys(utm).length) {
                const utmArr = [];
                for (const [k, v] of Object.entries(utm)) {
                    utmArr.push(`${k}=${v}`);
                }
                window.ca('set', 'utm', utmArr.join('&'));
            }
            // 统计 collect
            window.ca('set', 'cms', mergedInfo.cms);
            window.ca('set', 'tag', mergedInfo.tagIds);
            window.ca('send', type, { title: mergedInfo.title });
        }
    });
}
/**
 * 生成base64的二维码字符串，扫码后跳至公众号弹出外链
 * @description 可用于推荐关注后快速返回微站页面
 * @remarks
 * c_source 分享人openid
 * path 外链链接，会拼接上当前的utm参数
 * desc 外链描述
 * title 外链标题
 * image 外链图片
 */
export function getShareQrcode({ v = Date.now(), uaid = config.uaId, desc = '点击查看详情', path = window.location.href, c_source = '', title = document.title, image = config.logo } = {}) {
    return new Promise((resolve, reject) => {
        window.cw('shareQr', (qrcode) => {
            resolve(`data:image/png;base64,${qrcode}`);
        }, reject, {
            v,
            uaid,
            desc,
            path: concatURI(path, getUtm() || {}),
            c_source,
            title,
            image
        });
    });
}
